import { Badge, Button, Group, Paper, ScrollArea, Stack, Text, UnstyledButton } from '@mantine/core'

import type { ConversaWhatsApp } from '@/api/whatsapiOrg'
import { ORDEM_DOS_ESTADOS, ROTULO_DO_ESTADO, horario } from './textos'

const COR_DO_ESTADO = { aguardando: 'orange', em_atendimento: 'green', bot: 'blue' } as const

/**
 * Coluna da lista (spec 2026-11-02 conversas §5.7): "Aguardando humano", "Em atendimento"
 * (com quem) e "Com o bot", nessa ordem; dentro de cada grupo, a mais recente primeiro.
 */
export function ListaDeConversas({
  conversas, selecionada, aoEscolher, comGateway, temMais, carregandoMais, aoCarregarMais,
}: {
  conversas: ConversaWhatsApp[]
  selecionada: { gwId: string; ref: string } | null
  aoEscolher: (c: ConversaWhatsApp) => void
  /** Mostra o nome do gateway em cada conversa (mais de um gateway na lista). */
  comGateway: boolean
  temMais: boolean
  carregandoMais: boolean
  aoCarregarMais: () => void
}) {
  if (conversas.length === 0) {
    return <Text size="sm" c="dimmed">Nenhuma conversa ainda. Quando alguém mandar mensagem ao número do gateway, ela aparece aqui.</Text>
  }
  return (
    <ScrollArea.Autosize mah="70vh" type="auto">
      <Stack gap="md">
        {ORDEM_DOS_ESTADOS.map((estado) => {
          const doGrupo = conversas.filter((c) => c.estado === estado)
          if (doGrupo.length === 0) return null
          return (
            <Stack key={estado} gap={6} data-testid={`grupo-${estado}`}>
              <Group gap="xs">
                <Text size="sm" fw={600}>{ROTULO_DO_ESTADO[estado]}</Text>
                <Badge size="sm" variant="light" color={COR_DO_ESTADO[estado]}>{doGrupo.length}</Badge>
              </Group>
              {doGrupo.map((c) => {
                const ativa = selecionada?.gwId === c.gateway_id && selecionada.ref === c.ref
                return (
                  <UnstyledButton key={`${c.gateway_id}/${c.ref}`} onClick={() => aoEscolher(c)}
                    aria-current={ativa ? 'true' : undefined} aria-label={`Conversa com ${c.numero}`}>
                    <Paper withBorder p="xs" radius="md" bg={ativa ? 'var(--mantine-color-blue-light)' : undefined}>
                      <Group justify="space-between" wrap="nowrap" gap="xs">
                        <Text size="sm" ff="monospace">{c.numero}</Text>
                        <Text size="xs" c="dimmed">{horario(c.ultima_em)}</Text>
                      </Group>
                      {c.estado === 'em_atendimento' && (
                        <Text size="xs" c="green.8">
                          {c.atendente_e_voce ? 'Com você' : `Com ${c.atendente_nome ?? 'outra pessoa'}`}
                        </Text>
                      )}
                      {comGateway && <Text size="xs" c="dimmed">{c.gateway_nome}</Text>}
                      <Text size="xs" c="dimmed" lineClamp={1}>{c.previa || '[sem texto]'}</Text>
                    </Paper>
                  </UnstyledButton>
                )
              })}
            </Stack>
          )
        })}
        {temMais && (
          <Button variant="subtle" size="xs" loading={carregandoMais} onClick={aoCarregarMais}>
            Carregar mais conversas
          </Button>
        )}
      </Stack>
    </ScrollArea.Autosize>
  )
}
